import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { usePageMeta } from '@core/hooks/usePageMeta';
import type { PageMetaProps } from '@core/interfaces';

const UnderConstruction: React.FC<PageMetaProps> = (props) => {
  const { title, subtitle } = usePageMeta(props, {
    fallbackTitle: 'Under Construction',
  });

  return (
    <Container maxWidth="sm" sx={{ py: 12, flex: 1 }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          fontSize={70}
          fontWeight={600}
          color="primary"
          gutterBottom
        >
          🚧
        </Typography>

        <Typography variant="h4" fontWeight={600} color="primary" gutterBottom>
          {title}
        </Typography>

        {subtitle && (
          <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
            {subtitle}
          </Typography>
        )}

        <Typography variant="body1" color="text.secondary">
          Our team is working hard to bring you this feature. Check back soon!
        </Typography>
      </Box>
    </Container>
  );
};

export default UnderConstruction;
